import React, { useState } from 'react';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.userId, data.username);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Predefined accounts info (CTF EXPLOIT - buried in JS, find with DevTools)
  const accounts = [
    { username: 'admin', password: 'changeme' },
    { username: 'Ophelia Turner', password: 'the_pacific_driv3' },
    { username: 'Gordon Freeman', password: 'h4lf-life' },
    { username: 'Moira O\'Deorain', password: 'blackw4tch' },
    { username: 'Delilah June A.', password: 'Shoshone National Forest Firewatch' },
    { username: 'Cave Johnson', password: 'Make life take the lemons back! ' },
    { username: 'Professor E. Gadd', password: 'luigis mansi0n' }
  ];

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="scanline"></div>
      
      {/* CTF Challenge: Valid credentials hidden in HTML source */}
      <div style={{ display: 'none' }} data-ctf-hint="authorized-personnel-only">
        {accounts.map((acc, idx) => (
          <span key={idx} data-agent={acc.username} data-code={acc.password}></span>
        ))}
      </div>
      
      <div className="bg-dark-lighter rounded-lg shadow-neon-green border border-primary/30 p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary mb-2 font-mono glitch">
            [AUTH] ACCESS_CONTROL
          </h1>
          <p className="text-cyber-blue font-mono text-sm">
            &gt;&gt; CREDENTIAL_VERIFICATION_REQUIRED
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-primary font-mono text-sm mb-2">
              [USER] AGENT_ID:
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-dark border-2 border-primary/30 text-primary px-4 py-3
                       rounded-lg focus:outline-none focus:border-primary font-mono
                       focus:shadow-neon-green transition-all"
              placeholder="agent-name"
              required
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-primary font-mono text-sm mb-2">
              [PASS] ACCESS_CODE:
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-dark border-2 border-primary/30 text-primary px-4 py-3
                       rounded-lg focus:outline-none focus:border-primary font-mono
                       focus:shadow-neon-green transition-all"
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="bg-cyber-red/10 border border-cyber-red text-cyber-red px-4 py-3 rounded-lg font-mono text-sm">
              [ERROR] {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-primary text-dark font-bold font-mono py-4 px-6 rounded-lg
                     transform transition-all duration-200 border-2 border-primary
                     ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-neon-green hover:scale-105 hover:bg-transparent hover:text-primary'}`}
          >
            {loading ? '[VERIFYING] CREDENTIALS...' : '[LOGIN] ACCESS_SYSTEM →'}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-primary/30 font-mono text-xs">
            [SYSTEM] v2.0.1 | SECURE_ACCESS_PROTOCOL
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
